import React from 'react';
import { BaasicDropdown, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import SelectSkuQuantityTemplate from './SelectSkuQuantityTemplate';
import { observer } from 'mobx-react';
import _ from 'lodash';

const ReplacementTemplate = ({
	t,
	replacementViewStore,
	replacementViewStore: { selectedOrder, modalParams, loading },
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			{(_.get(selectedOrder, 'shippingAddress1') || _.get(modalParams, 'data.parentView.orderDetails')) && (
				<Replace t={t} replacementViewStore={replacementViewStore} />
			)}
		</React.Fragment>
	);
};

const Replace = observer(
	({
		t,
		replacementViewStore,
		replacementViewStore: {
			form,
			replacementReasonDropdownStore,
			requiredItemsMessage,
			productsForSelection,
		},
	}) => {
		return (
			<section>
				<form className="ReactModal__form" onSubmit={form.onSubmit}>
					<div className="ReactModal__header">
						<h3 className="spc--bottom--sml">{t('REPLACEMENTVIEW.TITLE')}</h3>
					</div>
					<div className="ReactModal__body">
						<div className="inputgroup spc--bottom--sml">
							<BaasicDropdown
								dropdownStore={replacementReasonDropdownStore}
								label="REPLACEMENTVIEW.REPLACEMENTREASON"
							/>
						</div>

						<SelectSkuQuantityTemplate
							t={t}
							viewStore={replacementViewStore}
							productsForSelection={productsForSelection}
							title={'REPLACEMENTVIEW.SELECTITEMS'}
							warningMessage={requiredItemsMessage}
						/>
					</div>
					<div className="ReactModal__footer">
						<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
							{t('SAVE')}
						</button>
						<button className="btn btn--med btn--ghost spc--bottom--sml" onClick={replacementViewStore.modalParams.close}>
							{t('CANCEL')}
						</button>
					</div>
				</form>
			</section>
		);
	}
);

export default defaultTemplate(ReplacementTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ReplacementTemplate.jsx